<template>
    <b-card no-body>
        <v-table    ref="table"
                    search
                    pagination = "server"
                    name="narli-ferry-boat"
                    :items-provider="provider"
                    :fields="fields">
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ReportsApi from '@/api/reports' 
export default {
    components:{
        BCard,
    },
    data(){
        return{
            fields:[
                { name:"Plaka",key:"PLATE_NUMBER" ,sortable:true,sortKey:'PLATE_NUMBER'},
                { name:"Geçiş Tarihi",key:"CreateDateFormatted",sortable:true,sortKey:'CREATE_DATE' },
                { name:"Fiyat (TL)(Vergi Hariç)",key:"PRICEWithoutTax",tdClass:"text-right" ,sortable:true,sortKey:'PRICE'},
                { name:"İndirim (TL)(Vergi Hariç)",key:"DISCOUNTWithoutTax",tdClass:"text-right" ,sortable:true,sortKey:'DISCOUNT'},
                { name:"Ödenen (TL)(Vergi Hariç)",key:"AMOUNTWithoutTax",tdClass:"text-right" ,sortable:true,sortKey:'AMOUNT'},
                { name:"Araç Tipi",key:"VEHICLE_TYPE_NAME",tdClass:"text-right",sortable:true,sortKey:'VEHICLE_TYPE_NAME' },
            ]
        }
    },
    methods:{
        provider(data){
           return ReportsApi.NarliFerryboat.Table(data)
        },
        
    }
}
</script>
